import createMortgageJourneyDocument from './createMortgageJourneyDocument';
import findMortgageJourneyDocument from './findMortgageJourneyDocument';
import startSavingMortgageJourney from './startSavingMortgageJourney';


/**
 * Attempt to locate an existing Mortgage Journey Document, or create a new one.
 * Using an option, can also begin saving any changes made to the Profile Service automatically.
 * 
 * @param {object} args
 * @param {string} args.purpose - what kind (refinance, purchase) of journey document?
 * @param {string} args.id - (OPTIONAL) Attempt to load a document with this ID. If we can't find it, null is returned.
 * @param {string} args.source - did it come from a calculator, wizard or application?
 * @param {object} args.sessionStore - reference to the SessionStore instance for the application
 * @param {boolean} args.enableSavingData - (OPTIONAL) if SAVING **AND** LOADING is enabled. Poorly named.
 * @param {string} args.locale - which locale the user is using
 *  
 * @returns {object|null} null is returned if asked to load a specific ID, and it's not in the user's profile.
 */
async function findOrCreateDocument({ id, purpose, source, sessionStore, enableSavingData, locale }) {
    
    // NOTE: Despite the name, it's actually if BOTH saving/loading are enabled.
    if (enableSavingData === false) {
        return createMortgageJourneyDocument({
            purpose,
            source,
            sessionStore,
            locale,
        });
    }

    // REQUIREMENT: if they requested a document by ID, and we can't find it, do NOT attempt to create a new one.
    // NOTE: failure to find is not necessarily an exception!
    // EXAMPLE: user bookmarks a URL with a documentId and revisits after cookies expired/cleared.
    const document = id
        ? await findMortgageJourneyDocument(sessionStore, { id })

        // REQUIREMENT: prefer to resume an existing document of the same purpose
        : (await findMortgageJourneyDocument(sessionStore, { purpose })
            ?? createMortgageJourneyDocument({
                purpose,
                source,
                sessionStore,
                locale,
            }));

    if (document) {
        startSavingMortgageJourney(document, { sessionStore });
    }

    return document;
}

export default findOrCreateDocument;
